var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ro__checkbox"},[(_vm.checked)?_c('b-icon-check-square-fill'):_c('b-icon-square')],1)}
var staticRenderFns = []

export { render, staticRenderFns }